import { Component, Input } from '@angular/core';
import { ButtonBaseComponent } from '../button-base.component';
import { ButtonOutline, ButtonOutlineType } from './button-outline.data';

@Component({
  selector: 'app-button-outline',
  templateUrl: 'button-outline.component.html',
  styleUrls: ['button-outline.component.scss'],
})
export class ButtonOutlineComponent extends ButtonBaseComponent {
  readonly ButtonOutline = ButtonOutline;

  @Input() isHighlight: boolean = false;
  @Input() typeOfButton: ButtonOutlineType = 'DIALOG';
  @Input() hotButton: string = '';

  constructor() {
    super();
  }
}
